import { create } from "zustand"
import { message } from "antd"
import type {
  VideoGenerationPointCostParams,
  VideoGenerationPointSavingOptions,
} from "~/common/billing/pointCosts"
import { useSessionStore } from "./session"

type PointBalanceState = {
  open: boolean
  videoOptions?: VideoGenerationPointCostParams & { cost: number }
  constraints?: Partial<VideoGenerationPointSavingOptions>
  close: () => void
}

export const usePointBalanceStore = create<PointBalanceState>((set) => ({
  open: false,
  close: () => set({ open: false }),
}))

let checking = false

export const ensureSufficientPoints = async (
  cost: number,
  videoOptions?: VideoGenerationPointCostParams,
  constraints?: Partial<VideoGenerationPointSavingOptions>,
): Promise<boolean> => {
  const session = useSessionStore.getState()
  if (!session.user) {
    session.openLoginModal()
    return false
  }
  if (checking) return false
  checking = true

  try {
    const user = await session.refreshPointBalance()
    if (!user) {
      session.openLoginModal()
      return false
    }
    if ((user.balance_info?.available_amount || 0) >= cost) return true

    usePointBalanceStore.setState({
      open: true,
      videoOptions: videoOptions ? { ...videoOptions, cost } : undefined,
      constraints,
    })
    return false
  } catch {
    void message.error("获取最新积点余额失败，请稍后重试")
    return false
  } finally {
    checking = false
  }
}
